export default function renderContentfulImports(): string {
  return `
    // THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT.

    import { Asset, Entry } from 'contentful'
    import { Document } from '@contentful/rich-text-types'
  `
}
